<app-poi-sync type="drivers-groups" *ngIf="driverG" [id]="driverG.id"></app-poi-sync>
